
export interface DtmProduct {
  category: string;
  sku: string;
  quantity?: string;
  price?: string;
  merchandising?: any;
}

interface DtmSuccess {
  orderId: string;
  pagamento: string;
  totalPrice: string;
  amountPaid: string;
  amountRemaining: string;
  amountTotal: string;
  coupon: string;
  couponAmount: string;
  appliedCoupons: Array<any>;
  installments: string;
  purchaseStatus: string;
  autoRecharge: boolean;
  bonusAmount: string;
  bonus: string;
}

export class DtmProductsInfo {

  items: Array<DtmProduct>;
  confirmacao: DtmSuccess;

  constructor() {
    this.items = new Array<DtmProduct>();
  }
}
